import { render, staticRenderFns } from "./SlotSettingsForm.vue?vue&type=template&id=3263f7d2&scoped=true&"
import script from "./SlotSettingsForm.vue?vue&type=script&lang=js&"
export * from "./SlotSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./SlotSettingsForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SlotSettingsForm.vue?vue&type=style&index=1&id=3263f7d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3263f7d2",
  null
  
)

export default component.exports